<div class="destinations-slider" *ngIf="!selectedGroup">
  <swiper [config]="config" [(index)]="index" class="destinations-thumbnail__content">
    <div class="destinations-thumbnail__wrapper"
         *ngFor="let group of destinationBox$ | async | chunk:2">
      <a class="destinations-thumbnail__element" *ngIf="group[0]"
         (click)="selectGroup(group[0])">
        <div class="destinations-thumbnail__img"
             [ngStyle]="{'background-image': 'url(' + (group[0].destinations[0]?.id | imageByCode:'destination' | async | cdnify) + ')'}"
        ></div>
        <div class="destinations-thumbnail__title">{{group[0].name}}</div>
      </a>
      <a class="destinations-thumbnail__element" *ngIf="group[1]"
         (click)="selectGroup(group[1])">
        <div class="destinations-thumbnail__img"
             [ngStyle]="{'background-image': 'url(' + (group[1].destinations[0]?.id | imageByCode:'destination' | async | cdnify) + ')'}"
        ></div>
        <div class="destinations-thumbnail__title">{{group[1].name}}</div>
      </a>
    </div>
  </swiper>
</div>
<div class="destination-slider" *ngIf="selectedGroup">
  <div class="destinations-thumbnail__cta-back">
    <button class="btn btn--outline btn--xs btn--font-normal" (click)="deselectGroup()"><i class="icon-chevron-left"></i> Torna Indietro</button>
  </div>
  <swiper [config]="config" [(index)]="index" class="destinations-thumbnail__content">
    <div class="destinations-thumbnail__wrapper" *ngFor="let destination of selectedGroup.destinations | chunk:2">
      <a class="destinations-thumbnail__element" *ngIf="destination[0]"
         (click)="selectDestination(destination[0])"
         [ngClass]="{'active': selectedDestinationInner === (destination[0])}">
        <div class="destinations-thumbnail__img" [ngStyle]="{'background-image': 'url(' + ((destination[0]).id | imageByCode:'destination' | async | cdnify) + ')'}"></div>
        <div class="destinations-thumbnail__title">{{(destination[0]).name}}</div>
      </a>
      <a class="destinations-thumbnail__element" *ngIf="destination[1]"
         (click)="selectDestination(destination[1])"
         [ngClass]="{'active': selectedDestinationInner === destination[1]}">
        <div class="destinations-thumbnail__img" [ngStyle]="{'background-image': 'url(' + (destination[1].id | imageByCode:'destination' | async | cdnify) + ')'}"></div>
        <div class="destinations-thumbnail__title">{{destination[1].name}}</div>
      </a>
    </div>
  </swiper>
</div>
